/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DropboxIcon = createIcon("DropboxIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M18.65 15.57v3.2L12 22.86l-6.65-4.09v-3.2",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.35 8.81-4.6 3.58 6.65 4.6L12 12.9 5.35 8.81ZM12 4.72 5.35 8.81.75 5.23 7.4 1.14 12 4.72Zm6.65 4.09 4.6 3.58-6.65 4.6L12 12.9l6.65-4.09ZM12 4.72l6.65 4.09 4.6-3.58-6.65-4.09L12 4.72Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});